import { Routes } from '@angular/router';
import { ShellLayoutComponent } from './membership/core/shell/shell.layout.component';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    title: 'Geneva Protection',
    loadComponent: () =>
      import('./visitor/home/home.page.component').then(
        (c) => c.HomePageComponent,
      ),
  },
  {
    path: 'login',
    title: 'Login',
    loadComponent: () =>
      import('./visitor/login/login.page.component').then(
        (c) => c.LoginPageComponent,
      ),
  },
  {
    path: 'signup',
    title: 'Signup',
    loadComponent: () =>
      import('./visitor/signup/signup.page.component').then(
        (c) => c.SignupPageComponent,
      ),
  },
  {
    path: 'app',
    title: 'Geneva Protection',
    component: ShellLayoutComponent,
    canActivate: [AuthGuard],  // Protection de la route avec AuthGuard
    loadChildren: () =>
      import('./membership/membership.routes').then((r) => r.membershipRoutes),
  },
];
